export interface VatTu {
    id?: string;
    itemId?: string;
    isUsed?: boolean;
    themDanhSachVatTu: VatTuGoiThauInterface;
};





export interface VatTuGoiThauInterface {
    columns2ColumnsText: string;
    isUsed?: boolean;
};

export const initialValuesVatTuGoiThau: VatTuGoiThauInterface = {
    columns2ColumnsText: null || "",
};

export const initialValuesVatTu: VatTu = {
    itemId: null || "",
    themDanhSachVatTu: initialValuesVatTuGoiThau,
}
